// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';

import BannersQuery from '../../components/Query/Banners';
import BannerDetail from './BannersDetail';
import { Title } from '../../components/Layout/components';

interface IBannersTableState {
  banner?: GQL.IBanner;
}

interface IBannersTableProps {
  domain: string;
}

export default class BannersTable extends React.Component<IBannersTableProps, IBannersTableState> {

  constructor(props: IBannersTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <BannersQuery domain={this.props.domain}>
            {({ banners, deleteBanner, createBanner, updateBanner }: any) => {
              return this.renderData(
                banners,
                updateBanner,
                createBanner,
                deleteBanner,
                banners.refetch
              );
            }}
          </BannersQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    bannersQuery: any,
    updateBanner: Function,
    createBanner: Function,
    deleteBanner: Function,
    refetch: Function
  ) {
    if (!bannersQuery.loading) {
      return (
        <div>
          <Title>Banners</Title>
          <Divider />
          <Button onClick={() => this.newBanner()}>Create new banner</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={bannersQuery.banners || []}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Name" dataIndex="name" key="name" />
            <Table.Column title="Banner type" dataIndex="type" key="type" />
            <Table.Column title="File" dataIndex="file" key="file" />
            <Table.Column title="Link" dataIndex="link" key="link" />
            <Table.Column
              width={200}
              title="Actions"
              dataIndex="actions"
              key="actions"
              render={(u: any, row: any) => this.renderActions(u, row, deleteBanner, refetch)}
            />
          </Table>
          {this.state &&
            this.state.banner && (
              <BannerDetail
                languages={bannersQuery.languages}
                banner={this.state.banner}
                onSave={a => this.upsert(a, updateBanner, createBanner, refetch)}
                onCancel={() => this.setCurrentBanner(undefined)}
              />
            )}
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading banners ..." style={{ width: '100%' }} />
      </div>
    );
  }

  // @ts-ignore
  private renderActions(u: any, banner: GQL.IBanner, deleteBanner: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.setCurrentBanner(banner)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(banner, deleteBanner, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newBanner() {
    this.setCurrentBanner({
      file: '',
      name: '',
      type: '',
      title: {},
      subtitle: {},
      description: {},
      link: '',
      priority: 1,
    });
  }

  private setCurrentBanner(banner: any) {
    this.setState({ banner });
  }

  private delete(banner: GQL.IBanner, deleteBanner: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete banner ${banner.name}?`,
      content: (
        <span>
          Are you sure you want to delete banner <strong>{banner.name}</strong>?
                </span>
      ),
      onOk: () => {
        return deleteBanner({
          variables: {
            id: banner.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    banner: GQL.IBanner,
    updateBanner: Function,
    createBanner: Function,
    refetch: Function
  ) {
    if (banner != undefined) {
      const variables = {
        id: banner.id,
        banner: {
          file: banner.file,
          productImage: banner.productImage,
          name: banner.name,
          type: banner.type,
          title: banner.title,
          subtitle: banner.subtitle,
          description: banner.description,
          link: banner.link,
          priority: banner.priority || 1
        }
      };

      if (banner.id) {

        return updateBanner({ variables })
          .then(() => this.setCurrentBanner(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Banner "${variables.banner.name}" has been updated.`
            })
          );
      }

      (variables.banner as any).domain = this.props.domain;

      createBanner({ variables })
        .then(() => this.setCurrentBanner(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Banner "${variables.banner.name}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Banners/BannersTable.tsx